export const hasToken = ({ token }) => !!token

export const isAdmin = state => {
  if (state?.user?.is_super_admin) return true
  const roleName = state?.user?.role_details?.name || ''
  const roleLegacy = (state?.user?.role || '').toLowerCase()
  return roleName === 'administrator' || roleLegacy === 'admin' || roleLegacy === 'administrador'
}
export const isMaster = state => {
  if (state?.user?.is_super_admin) return true
  const roleName = state?.user?.role_details?.name || ''
  const roleLegacy = (state?.user?.role || '').toLowerCase()
  return roleName === 'master' || roleLegacy === 'master'
}
export const isOperator = state => {
  const roleName = state?.user?.role_details?.name || ''
  const roleLegacy = (state?.user?.role || '').toLowerCase()
  return roleName === 'operator' || roleLegacy === 'operator' || roleLegacy === 'operador'
}
export const isViewer = state => {
  const roleName = state?.user?.role_details?.name || ''
  const roleLegacy = (state?.user?.role || '').toLowerCase()
  return roleName === 'viewer' || roleLegacy === 'viewer' || roleLegacy === 'visualizador'
}
export const userRole = state => state?.user?.role_details?.label || state?.user?.role

// Getters para o novo sistema de permissões
export const isSuperAdmin = state => state?.user?.is_super_admin || false
export const userPermissions = state => state?.user?.permissions || []
export const hasPermission = state => (permission) => {
  // Super admin tem todas as permissões
  if (state?.user?.is_super_admin) {
    return true
  }
  // Verifica se o usuário tem a permissão específica
  const permissions = state?.user?.permissions || []
  return permissions.includes(permission)
}
export const hasAnyPermission = state => (permissionsArray) => {
  // Super admin tem todas as permissões
  if (state?.user?.is_super_admin) {
    return true
  }
  // Verifica se o usuário tem pelo menos uma das permissões
  const userPerms = state?.user?.permissions || []
  return permissionsArray.some(p => userPerms.includes(p))
}
export const hasAllPermissions = state => (permissionsArray) => {
  // Super admin tem todas as permissões
  if (state?.user?.is_super_admin) {
    return true
  }
  // Verifica se o usuário tem todas as permissões
  const userPerms = state?.user?.permissions || []
  return permissionsArray.every(p => userPerms.includes(p))
}
